import i18n from "../i18n"
import { GA_USERTYPES } from "./constants";
import { languageOptions, getCleanURL } from "./Utils"

/**
 * !! user_id is null at app init. After init, identity_ready fires to send user_id to GA4 !!
 * Refer App.js -> identity_ready
 */

export const pushToDataLayer = (eventName, data = {}, isAllowToTrackAll = false) => {
    if (typeof window === 'undefined' || !window.dataLayer) return;
    const langConfig = languageOptions[i18n.resolvedLanguage] || {};

    const { isProd, sapContactNo, sapAccountNo, sapCustomerGroup, trafficType, ...restData } = data;

    // Always send User ID when present, if it's null, dont push it - pushing an empty ID corrupts the GA4 data.
    let userID;

    if (sapContactNo) {
        userID = sapContactNo
    } 
    
    // If need in future
    // else if (gid) {
    //     // for Internal User
    //     userID = gid
    // } else if (dkid) {
    //     // for external indirect we can use Doorkeeper ID
    //     userID = dkid
    // }

    const payload = {
        ...restData,
        event: eventName,
        ...(trafficType && { traffic_type: trafficType }),
        ...(sapAccountNo && sapContactNo && {
            sap_contact_id: sapContactNo,
            sap_account_id: sapAccountNo,
            sap_customer_group: sapCustomerGroup,
        }),
        ...(userID && { user_id: userID }),
        timestamp: new Date().toISOString(),
        page_url: getCleanURL(),
        page_path: window.location.pathname,
        version: '1.0.0',
        country: langConfig.country || "unknown",
        language: langConfig.languageCode || "unknown"
    };

    if (payload?.sap_account_id) {
        payload.user_type = GA_USERTYPES.EXTERNAL_DIRECT
    }

    if (sapAccountNo && sapContactNo && userID) {
        window.dataLayer.push(payload);
    } else if (isAllowToTrackAll && userID) {
        window.dataLayer.push(payload);
    } else if (isAllowToTrackAll && restData.sap_account_id) {
        window.dataLayer.push(payload);
    } else {
        if (!isProd) {
            console.warn("[GTM] Skipped (no sap_account_id):", payload);
        }
        return;
    };

    if (!isProd) {
        console.log("[GTM] Event:", payload);
    };
};